import { EstadosSolicitudEnumChoice } from '@/shared';
import { ChipModelState } from '@/shared/components/ui';

export interface EstadoCodigoOTPTableProps {
  estado: string;
}

const EstadoCodigoOTPTable: React.FC<EstadoCodigoOTPTableProps> = ({
  estado,
}) => {
  return (
    <>
      {estado === EstadosSolicitudEnumChoice.EN_ESPERA ? (
        <ChipModelState color="warning" label="PENDIENTE" />
      ) : estado === EstadosSolicitudEnumChoice.FINALIZADO ? (
        <ChipModelState color="error" label="CADUCADO" />
      ) : estado === EstadosSolicitudEnumChoice.APROBADO ? (
        <ChipModelState color="success" label="VERIFICADO" />
      ) : (
        'N/A'
      )}
    </>
  );
};

export default EstadoCodigoOTPTable;
